import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class ReduxFormsDateTimeField extends Component {
  render() {
    const { label, required, children, input, meta: { touched, error } } = this.props;

    const scaffoldClasses = {
      'input-scaffold': true,
      [`${this.props.className}`]: this.props.className,
    };

    return (
      <div className={classNames(scaffoldClasses)}>
        {label ? (
          <span className="input-label">
            {label}
            {!required ? <span className="input-label--optional">optional</span> : null}
          </span>
        ) : (
          <span />
        )}
        {React.cloneElement(children, input)}
        {touched && error ? <div className="input-validation">{error}</div> : null}
      </div>
    );
  }
}

ReduxFormsDateTimeField.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  required: PropTypes.bool,
};

ReduxFormsDateTimeField.defaultProps = {
  children: null,
  className: null,
  disabled: false,
  label: null,
  validation: null,
};

export default ReduxFormsDateTimeField;



// WEBPACK FOOTER //
// ./src/common/forms/ReduxFormsDateTimeField.js